import { usePutHttp } from "../../../../hooks/http/http.hook";
import type { IPost } from "../../../../types/models/post.models.types";

export interface IPostResponse {
  post: IPost;
}

export function useApprovePostHttp() {
  return usePutHttp<null, IPostResponse>({
    path: "/brand/posts/:id/approve-post",
  });
}
